import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import './registerServiceWorker'
import ScrollView from 'vue-scrollview'
import { sync } from 'vuex-router-sync'
import vSelect from 'vue-select'
import VueAnalytics from 'vue-analytics'
import { googleAnalyticsID } from './api/config'

Vue.config.productionTip = false
const options = {
  throttle: 250
}
Vue.use(ScrollView, options)
Vue.use(VueAnalytics, {
  id: googleAnalyticsID,
  router
})

Vue.component('v-select', vSelect)

sync(store, router)

window.requestAnimationFrame = window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (f) { return setTimeout(f, 1000 / 60) }

window.cancelAnimationFrame = window.cancelAnimationFrame ||
  window.mozCancelAnimationFrame ||
  function (requestID) { clearTimeout(requestID) }

function replaceConjunctions (text) {
  if (text && typeof text === 'string') {
    let lettersToReplace = ['a', 'i', 'o', 'u', 'w', 'z', 'do', 'A', 'I', 'O', 'U', 'W', 'Z', 'and', 'or']
    let arrayLength = lettersToReplace.length
    for (let i = 0; i < arrayLength; i++) {
      let textSplit = text.split(' ' + lettersToReplace[i] + ' ')
      text = textSplit.join(' ' + lettersToReplace[i] + '\u00A0')
      textSplit = text.split('$$' + lettersToReplace[i] + ' ')
      text = textSplit.join('$$' + lettersToReplace[i] + '\u00A0')
    }
    return text
  } else {
    return ''
  }
}
function accentString (str, uppercase) {
  if (str) {
    let goodStr = replaceConjunctions(str)
    return goodStr.split('$$').map((el, index) => {
      if (uppercase) {
        if (index % 2 === 0) {
          return el.toUpperCase()
        }
        return '<span class="accent">' + el.toUpperCase() + '</span>'
      } else {
        if (index % 2 === 0) {
          return el
        }
        return '<span class="accent">' + el + '</span>'
      }
    }).join('')
  } else {
    return ''
  }
}

Vue.directive('accent', {
  bind: function (el, binding) {
    el.innerHTML = accentString(binding.value, binding.modifiers.uppercase)
  },
  componentUpdated: function (el, binding) {
    if (binding.oldValue !== binding.value) {
      el.innerHTML = accentString(binding.value, binding.modifiers.uppercase)
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
